/**
 *
 * Spinner
 *
 */
import React from 'react';
import classnames from 'classnames';
import UnsafeHtml from '../UnsafeHtml';
import LOADING_LABEL from './constant';

var Spinner = function Spinner(_ref) {
  var isVisible = _ref.isVisible,
      displayType = _ref.displayType,
      size = _ref.size,
      displayText = _ref.displayText,
      accessibilityLabel = _ref.accessibilityLabel;
  if (!isVisible) return null;
  return React.createElement(React.Fragment, null, React.createElement("span", {
    className: classnames('fil-spinner', "fil-spinner__".concat(displayType)),
    role: "status",
    "aria-live": "assertive",
    "aria-label": accessibilityLabel
  }, React.createElement("span", {
    className: classnames('fil-spinner__spins', "fil-spinner__spins--".concat(size))
  }, React.createElement("span", {
    className: "spin"
  }), React.createElement("span", {
    className: "spin"
  }), React.createElement("span", {
    className: "spin"
  })), displayText && React.createElement("span", {
    className: "fil-spinner__text"
  }, React.createElement(UnsafeHtml, null, displayText))), displayType === 'fixed' && React.createElement("div", {
    className: "fil-spinner__overlay"
  }));
};

Spinner.defaultProps = {
  text: '',
  accessibilityLabel: LOADING_LABEL
};
Spinner.displayName = 'Spinner';
export default Spinner;